import { createContext } from 'react'

const TobiSupportContext = createContext({
  openTobiModal: () => { },
  toolTipsModalRef: null,
})

export default TobiSupportContext
